'use client'

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './lang/en'
import ko from './lang/ko'
import ktpEn from './lang/ktp-en'
import ktpKo from './lang/ktp-ko'

export const SUPPORTED_LANGUAGES = ['en', 'ko']

const resources = {
  en: { ...en, ...ktpEn },
  ko: { ...ko, ...ktpKo },
}

const getInitialLng = () => {
  try {
    if (typeof window === 'undefined') return 'ko'
    const supported = SUPPORTED_LANGUAGES
    const stored = localStorage.getItem('i18nextLng')
    if (stored && supported.includes(stored)) return stored
    // navigator 언어에서 기본값 추론
    const nav = (navigator?.language || 'ko-KR').split('-')[0]
    const initial = supported.includes(nav) ? nav : 'ko'
    localStorage.setItem('i18nextLng', initial)
    return initial
  } catch (_) {
    return 'ko'
  }
}

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      lng: getInitialLng(),
      fallbackLng: 'ko',
      supportedLngs: SUPPORTED_LANGUAGES,
      ns: ['common', 'ktp'],
      defaultNS: 'common',
      fallbackNS: 'common',
      interpolation: { escapeValue: false },
      detection: {
        order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
      },
    })
    .catch(() => {})

  // Ensure localStorage sync on language change
  i18n.on('languageChanged', lng => {
    try {
      if (typeof window !== 'undefined') {
        localStorage.setItem('i18nextLng', lng)
        document.documentElement.lang = lng
      }
    } catch (_) {}
  })
}

export default i18n
